export const USER_MODEL_OPTIONS = {
  'django': 'Default Django (username + password)',
  'custom-username': 'Custom user model (username + password)',
  'custom-email': 'Custom user model (email + password)'
}

export const STATIC_FILES_OPTIONS = {
  'whitenoise': 'Serve from Django using whitenoise',
  'storages': 'Serve from cloud storage using django-storages',
  '': "Don't serve static files from Django"
}

export const FILE_STORAGE_OPTIONS = {
  'aws-s3': 'Amazon S3 (using django-storages)',
  'azure': 'Azure (using django-storages)',
  'do-spaces': 'Digital Ocean Spaces (using django-storages)',
  'gcloud': 'Google Cloud Storage (using django-storages)',
  '': 'Store locally on disk'
}

export const FIELD_TYPE_OPTIONS = {
  'models.ForeignKey': 'ForeignKey',
  'models.OneToOneField': 'OneToOneField',
  'models.ManyToManyField': 'ManyToManyField',
  'models.CharField': 'CharField',
  'models.TextField': 'TextField',
  'models.EmailField': 'EmailField',
  'models.URLField': 'URLField',
  'models.IntegerField': 'IntegerField',
  'models.DecimalField': 'DecimalField',
  'models.BooleanField': 'BooleanField',
  'models.DateTimeField': 'DateTimeField',
  'models.DateField': 'DateField',
  'models.ImageField': 'ImageField',
  'models.FileField': 'FileField',
  'models.JSONField': 'JSONField'
}

export const ON_DELETE_OPTIONS = {
  'SET_NULL': 'Set to NULL',
  'CASCADE': 'Cascade (delete this object)',
  'PROTECT': 'Protect (disallow related object deletion)'
}

export const BOOL_DEFAULT_OPTIONS = {
  true: 'True',
  false: 'False',
  null: '(no default)'
}

export const DATETIME_DEFAULT_OPTIONS = {
  'now': 'Date/time of creation (can be overridden)',
  'auto-create': 'Date/time of creation (cannot be overridden)',
  'auto-update': 'Date/time of last update (cannot be overridden)',
  null: '(no default)'
}

export const DATE_DEFAULT_OPTIONS = {
  'now': 'Date of creation (can be overridden)',
  'auto-create': 'Date of creation (cannot be overridden)',
  'auto-update': 'Date of last update (cannot be overridden)',
  null: '(no default)'
}

export const EMPTY_MODEL = {
  name: '',
  docstring: '',
  str_field: null,
  admin: {
    list_fields: [],
    search_fields: [],
    filter_fields: []
  },
  viewset: null,
  serializer: null,
  owner_field: null,
  fields: []
}

export const EMPTY_FIELD = {
  name: '',
  type: '',
  verbose_name: '',
  help_text: '',
  useChoices: false,
  choices: {},
  unique: false,
  null: false,
  on_delete: 'CASCADE',
  target: null,
  read_only: false,
  max_len: null,
  min_val: null,
  max_val: null,
  decimal_places: null,
  max_digits: null,

  includeInSerializer: true,
  adminListField: false,
  adminSearchBy: false
}

export const RELATIONAL_FIELDS = ['models.ForeignKey', 'models.OneToOneField', 'models.ManyToManyField']
export const SINGLE_REL_FIELDS = ['models.ForeignKey', 'models.OneToOneField']
export const NUMBER_FIELDS = ['models.IntegerField', 'models.DecimalField']
export const LIMITED_TEXT_FIELDS = ['models.CharField', 'models.EmailField', 'models.URLField']
export const TEXT_FIELDS = LIMITED_TEXT_FIELDS.concat(['models.TextField'])
export const FILE_FIELDS = ['models.ImageField', 'models.FileField']
export const DATE_FIELDS = ['models.DateTimeField', 'models.DateField']

export const API_PERMISSION_OPTIONS = {
  any: 'Anyone',
  auth: 'Authenticated users',
  owner: 'Owner',
  admin: 'Admin',
  none: 'Nobody'
}

export const PYTHON_KEYWORDS = [
  'False', 'None', 'True', 'and', 'as', 'assert', 'async', 'await', 'break', 'class', 'continue',
  'def', 'del', 'elif', 'else', 'except', 'finally', 'for', 'from', 'global', 'if', 'import', 'in', 'is',
  'lambda', 'nonlocal', 'not', 'or', 'pass', 'raise', 'return', 'try', 'while', 'with', 'yield'
]

export const EMAIL_PROVIDER_OPTIONS = {
  '': '(disable e-mail support)',
  'smtp': 'Send via any SMTP server',
  'ses': 'Amazon SES',
  'mailgun': 'Mailgun',
  'mailjet': 'Mailjet',
  'mandrill': 'Mandrill',
  'postal': 'Postal',
  'postmark': 'Postmark',
  'sendgrid': 'SendGrid',
  'sendinblue': 'Sendinblue',
  'sparkpost': 'SparkPost'
}



// WEBPACK FOOTER //
// ./src/helpers/constants.js